import { $sections } from '@/services/'
import Vue from 'vue'

const module = {
    namespaced: true,
    state: {
      map: null,
      drawingManager: null,
      selectedShape: null,
      allShapes: [],
      rotationDegree: 3
    },
    actions: {
      setMap({commit}, value){
        commit('MAP', value)
      },
      setDrawingManager({commit}, value){
        commit('DRAWING_MANAGER', value)  
      },
      addShape({commit}, value){
        commit('ADD_SHAPE', value)
      },
      setSelectedShape({commit}, {value, autoZoom}){
        commit('SELECTED_SHAPE', {value, autoZoom})
      },
      setShapeOptions({commit}, value){
        commit('SHAPE_OPTIONS', value)
      },
      reset({commit}){
        commit('SELECTED_SHAPE', null)
        commit('')
      },
      rotate({commit}, direction){
        commit('ROTATE', direction)
      },
      resetDraggable({commit}){
        commit('RESET_DRAG')
      },
      deleteShape({commit}, id){
        commit('DELETE_SHAPE', id)
      },
      updateShape({commit}, id){
        commit('UPDATE_SHAPE', id)
      },
      autoSetCoordinates({commit}, id){
        commit('AUTOSET_COORDINATES', {item: id})
      },
      copyShape({commit}, id){
        
      },
      updateShapeFromDimension({commit}, {section, data}){
        commit('AUTO_SET_FROM_DIMENSION', {commit, section, data})
      },
      bulkDeleteShapes({commit}, ids){
        commit('BULK_DELETE_SHAPES', ids)
      }
    },
    mutations: {
      MAP: (state, value) => {
        state.map = value
        google.maps.Polyline.prototype.getBoundingBox = function() {
          var bounds = new google.maps.LatLngBounds();
          this.getPath().forEach(function(element,index) {
            bounds.extend(element)
          });
          return(bounds);
        };

        google.maps.Polygon.prototype.getBoundingBox = function() {
          var bounds = new google.maps.LatLngBounds();
          this.getPath().forEach(function(element,index) {
            bounds.extend(element)
          });
          return(bounds);
        };

        google.maps.Polygon.prototype.rotate = function (angle, latLng, map) {
          map = map || this.getMap();

          if (map === undefined) {
            console.warn('No valid google maps object found');
            return;
          }

          var coords = this.getPath().getArray();
          var projection = map.getProjection();
          var origin = projection.fromLatLngToPoint(latLng);

          coords.forEach(function (point, index) {
            var pixelCoord = projection.fromLatLngToPoint(point).rotate(angle, origin);

            coords[index] = projection.fromPointToLatLng(pixelCoord);
          });
          this.setOptions({updateEvent: true})
          this.setPaths(coords);
          google.maps.event.trigger(this, 'dragend', this);
        };

        google.maps.Point.prototype.rotate = function (angle, origin) {
          var rad = angle * (Math.PI / 180);

          var x = this.x - origin.x;
          var y = this.y - origin.y;

          return new google.maps.Point(
            x * Math.cos(rad) - y * Math.sin(rad) + origin.x,
            x * Math.sin(rad) + y * Math.cos(rad) + origin.y
          );
        };

        google.maps.LatLng.prototype.rotate = function (angle, origin) {
          var radianAngle = angle * (Math.PI / 180);

          var radius = this.distanceTo(origin);
          var theta = radianAngle + Math.atan2(this.lng() - origin.lng(), this.lat() - origin.lat());

          var x = origin.lat() + (radius * Math.cos(theta));
          var y = origin.lng() + (radius * Math.sin(theta));

          return new google.maps.LatLng(x, y);
        };

        google.maps.LatLng.prototype.distanceTo = function (point) {
          var lat = Math.pow(this.lat() - point.lat(), 2);
          var lng = Math.pow(this.lng() - point.lng(), 2);

          return Math.sqrt(lat + lng);
        };
      },
      DRAWING_MANAGER: (state, value) => state.drawingManager = value,
      ADD_SHAPE: (state, value) => state.allShapes.push(value),
      
      SELECTED_SHAPE: (state, {value, autoZoom}) => {
        state.allShapes.forEach(sh => {
          sh.setOptions({editable: false})
        })
        state.selectedShape = value
        if(value){
          value.setOptions({editable: true})
        }

        state.allShapes.forEach(sh => {
          (sh.lengthMarkers || []).map(lm => lm.setMap(null))
        })
        if(value){
          ((value.shape || value).lengthMarkers || []).map(m => m.setMap(state.map))
          const shape = (value.shape || value)
          
          if(autoZoom){
            let bounds = new google.maps.LatLngBounds();
            if((shape instanceof google.maps.Polygon || shape instanceof google.maps.Polyline)){
              shape.getPath().getArray().forEach(function(element,index) {
                bounds.extend(element)
              });
              state.map.fitBounds(bounds)
            } else if(shape instanceof google.maps.Marker){
              bounds.extend(shape.position)
              state.map.fitBounds(bounds)
              window.setTimeout(() => {
                shape.setOptions({
                  animation: google.maps.Animation.DROP,
                })
              }, 5000);
            }
          }
        }
      },
      
      SHAPE_OPTIONS: (state, value) => {
        if(state.selectedShape){
          console.log("Option is ", value)
          state.selectedShape.setOptions(value)
          if(state.selectedShape.centerMarker){
            state.selectedShape.centerMarker.setOptions(value)
          }
        }
      },

      ROTATE: (state, value) => {
        if(!state.selectedShape){
          return
        }
        let rotationDegree = state.rotationDegree
        if(value == 'left'){
          rotationDegree = rotationDegree * -1
        }
        const center = state.selectedShape.getBoundingBox().getCenter()
        state.selectedShape.rotate(rotationDegree, center, state.map)
      },

      RESET_DRAG: (state, value) => {
        state.allShapes.map(sh => sh.setOptions({draggable: false}))
      },
      DELETE_SHAPE: (state, id) => {
        const shape = state.allShapes.filter(sh => sh.id == id)[0]
        if(shape.centerMarker){
          shape.centerMarker.setMap(null)
        }
        if(shape.lengthMarkers){
          shape.lengthMarkers.map(lm => lm.setMap(null))
        }
        shape.setMap(null)
      },
      UPDATE_SHAPE: (state, item) => {
        let shape = state.allShapes.filter(sh => sh.id == item.id)[0]
        if(shape.shape){
          shape = shape.shape
        }

        if(shape.centerMarker){
          if(shape.centerMarker instanceof google.maps.Marker){
            shape.centerMarker.setLabel(item.label)
          } else {
            shape.resetEquipmentIcon()
          }
        } else {
          if(shape instanceof google.maps.Marker){
            shape.setLabel(item.label)
          }
        }
      },
      AUTOSET_COORDINATES: (state, {item, options = {}, fromInput}) => {
        let shape = state.allShapes.filter(sh => sh.id == item.id)[0]
        if(!shape){
          console.error("No shape found for item ID:", item.id)
          return
        }
        if(shape.shape){
          shape = shape.shape
        }

        let coords_arr = shape.getPath().getArray()
        
        if((coords_arr.length < 3 || coords_arr.length > 4) || !shape.equipmentId){
          return
        }
        let dist = google.maps.geometry.spherical.computeDistanceBetween(coords_arr[0], coords_arr[1]);
        let heading = google.maps.geometry.spherical.computeHeading(coords_arr[0], coords_arr[1]);
        let heading2 = heading
        let lat1 = coords_arr[0].lat()
        let lat2 = coords_arr[1].lat()
        let lng1 = coords_arr[0].lng()
        let lng2 = coords_arr[1].lng()
        let lat3 = coords_arr[2].lat()
        let lng3 = coords_arr[2].lng()
        let deltaLat = lat2 - lat1
        let deltaLng = lng2 - lng1

        let deltaLat2 = lat3 - lat2
        let deltaLng2 = lng3 - lng2

        let dir = null

        if(deltaLat >= 0 && deltaLng >= 0){
          dir = "ne"
        }else if(deltaLat >= 0 && deltaLng <= 0){
          dir = "nw"
        } else if(deltaLat <= 0 && deltaLng <= 0){
          dir = "sw"
        } else if(deltaLat <= 0 && deltaLng >= 0){
          dir = "se"
        }

        if(deltaLat2 >= 0 && deltaLng2 >= 0){
          console.log("ne")
          heading2 = heading2 - 90
        }else if(deltaLat2 >= 0 && deltaLng2 <= 0){
          heading2 = heading2 + 90
          console.log("nw")
        } else if(deltaLat2 <= 0 && deltaLng2 <= 0){
          heading2 = heading2 + 90
          console.log("sw")
        } else if(deltaLat2 <= 0 && deltaLng2 >= 0){
          heading2 = heading2 + 90
          console.log("se")
        }

        console.log(heading)
        console.log(heading2)
        if(dir == "ne"){
          if(heading > 0){
            dist = dist * -1
          }
        } else if(dir == "se"){
          if(heading > 0){
            dist = dist * -1
          }
        } else if(dir == "sw"){
          if(heading < 0 ){
            dist = dist * -1
          }
        } else if(dir =="nw"){
          if(heading  < 0 ){
            dist = dist * -1
          }
        }

        let newCoord = google.maps.geometry.spherical.computeOffset(coords_arr[2], dist, heading);

        if(coords_arr[3]){
          coords_arr[3] = newCoord
        } else {
          coords_arr.push(newCoord)
        }
        shape.setPath(coords_arr)
        let length, width
        if(fromInput){
          length = item.equipment_detail.data.length / 100
          width = item.equipment_detail.data.width / 100
        } else {
          let firstLength = google.maps.geometry.spherical.computeDistanceBetween(coords_arr[0], coords_arr[1]);
          let secondLength = google.maps.geometry.spherical.computeDistanceBetween(coords_arr[1], coords_arr[2]);
          length = firstLength > secondLength ? firstLength : secondLength
          width = firstLength > secondLength ? secondLength : firstLength
        }
        length = Math.round(length*100)
        width = Math.round(width*100)
        item.equipment_detail.data = {
          ...item.equipment_detail.data,
          ...{
            length: length,
            width: width,
            lockedFromInput: fromInput
          }
        }
        if((options || {}).useSectionFromShape){
          shape.setOptions({useSectionFromShape: true})
        }
        shape.setOptions({updateEvent: true})
        google.maps.event.trigger(shape, 'dragend', shape);
      },

      CLONE_SECTION: (state, item) => {

      },

      AUTO_SET_FROM_DIMENSION: (state, {commit, section, data}) => {
        let shape = state.allShapes.filter(sh => sh.id == section.id)[0]
        if(shape instanceof google.maps.Polygon){
          let coords_arr = shape.getPath().getArray()
        
          if((coords_arr.length < 3 || coords_arr.length > 4) || !shape.equipmentId){
            return
          }

          let firstLength = google.maps.geometry.spherical.computeDistanceBetween(coords_arr[0], coords_arr[1]) * 100;
          let secondLength = google.maps.geometry.spherical.computeDistanceBetween(coords_arr[1], coords_arr[2]) * 100;

          let heading1 = google.maps.geometry.spherical.computeHeading(coords_arr[0], coords_arr[1]);
          let heading2 = google.maps.geometry.spherical.computeHeading(coords_arr[1], coords_arr[2]);

          let length = parseFloat(data.length)
          let width = parseFloat(data.width)

          if(data.fromInput){
            firstLength = length || firstLength
            secondLength = width || secondLength
          } else {
            let tempFirst = length || firstLength
            let tempSecond = width || secondLength
            firstLength = tempFirst > tempSecond ? tempFirst : tempSecond
            secondLength = tempFirst > tempSecond ? tempSecond : tempFirst
          }

          const coord1 = google.maps.geometry.spherical.computeOffset(coords_arr[0], firstLength/100, heading1);
          const coord2 = google.maps.geometry.spherical.computeOffset(coord1, secondLength/100, heading2);

          coords_arr[1] = coord1
          coords_arr[2] = coord2

          shape.setPath(coords_arr)
          if(data.useSectionFromShape){
            const obj = { useSectionFromShape: true}
            commit('AUTOSET_COORDINATES', {item: section, options: obj, fromInput: data.fromInput})
          } else {
            commit('AUTOSET_COORDINATES', {item: section, fromInput: data.fromInput})
          }
        }
      },
      BULK_DELETE_SHAPES: (state, ids) => {
        let shapesToRemove = state.allShapes.filter(sh => ids.includes(sh.id))
        shapesToRemove.forEach(shape => {
          if(shape.centerMarker){
            shape.centerMarker.setMap(null)
          }
          if(shape.lengthMarkers){
            shape.lengthMarkers.map(lm => lm.setMap(null))
          }
          shape.setMap(null)
        })
      }
    },
    getters: {
      map: (state) => state.map,
      drawingManager: (state) => state.drawingManager,
      allShapes: (state) => state.allShapes,
      selectedShape: (state) => state.selectedShape
    }
}

export default module